module.exports = __webpack_public_path__ + "assets/img/step-2-ecf54636.png";